import isEmpty from 'lodash/isEmpty';
//import ValidationMessages from '../helpers/ValidationMessages';

function validateInput(data) {
  let errors = {};

  // Administrator Verification
  if (data.adminVerification === false) {
    errors.adminVerification = 'Please verify administrator details';
  }

  // T&C Agreement Verification
  if (data.termsVerification === false) {
    errors.termsVerification = 'Please verify T&C agreement';
  }

  // Business Verification (check both notarion and international if applicable)
  if (data.notarionVerification === false) {
    errors.businessVerification = 'Please verify notarion business documents';
  }

  if (data.internationalVerification === false) {
    errors.businessVerification = 'Please verify international business documents';
  }

  // Banking Details Verification
  if (data.bankVerification === false) {
    errors.bankVerification = 'Please verify bank details';
  }

  // Operational Hours Verification
  if (data.timeVerification === false) {
    errors.timeVerification = 'Please verify operational hours';
  }

  return {
    errors,
    isValid: isEmpty(errors),
  };
}

export default validateInput;
